import React, { useRef } from 'react';
import { MAX_TEXT_LENGTH } from '../types';
import { TextEditorProps } from '../../type';
import EmojiPickerInput from '../../../components/EmojiPickerInput';

const TextEditor: React.FC<TextEditorProps> = ({
    reviewerName,
    reviewText,
    onReviewerNameChange,
    onReviewTextChange,
}) => {
    const textLength = reviewText.length;
    const remainingChars = Math.max(0, MAX_TEXT_LENGTH - textLength);

    const nameInputRef = useRef<HTMLInputElement>(null);
    const textAreaRef = useRef<HTMLTextAreaElement>(null);

    const handleReviewTextChange = (newText: string) => {
        if (newText.length > MAX_TEXT_LENGTH) {
            const truncated = newText.substring(0, MAX_TEXT_LENGTH - 3) + '...';
            onReviewTextChange(truncated);
        } else {
            onReviewTextChange(newText);
        }
    };

    return (
        <>
            <div className="self-stretch flex flex-col justify-start items-start gap-2 relative">
                <div className="self-stretch justify-center text-[#393939] text-base font-semibold font-['Montserrat'] leading-tight">
                    Nom à afficher
                </div>
                <div className="self-stretch bg-white rounded-sm outline outline-1 outline-offset-[-1px] outline-[#e4e4e4] flex flex-col justify-start items-end">
                    <div className="self-stretch p-3 inline-flex justify-start items-start gap-2.5 overflow-hidden">
                        <input
                            ref={nameInputRef}
                            id="reviewer-name"
                            type="text"
                            value={reviewerName}
                            onChange={e => onReviewerNameChange(e.target.value)}
                            className="flex-1 self-stretch justify-start text-[#393939] text-[13px] font-normal font-['Montserrat'] leading-none bg-transparent border-none outline-none focus:outline-none"
                            placeholder="Henri Amiel"
                            maxLength={50}
                        />
                    </div>
                    <div className="self-stretch p-3 bg-[#efefef] border-t border-[#e4e4e4] inline-flex justify-end items-end gap-3 relative overflow-visible">
                        <EmojiPickerInput
                            value={reviewerName}
                            onChange={onReviewerNameChange}
                            inputRef={nameInputRef}
                        />
                    </div>
                </div>
            </div>

            <div className="self-stretch flex-1 flex flex-col justify-start items-start gap-2">
                <div className="self-stretch justify-center text-[#393939] text-base font-semibold font-['Montserrat'] leading-tight">
                    Avis
                </div>
                <div className="self-stretch flex-1 bg-white rounded-sm outline outline-1 outline-offset-[-1px] outline-[#e4e4e4] flex flex-col justify-start items-end">
                    <div className="self-stretch flex-1 p-3 inline-flex justify-start items-start gap-2.5 overflow-hidden">
                        <textarea
                            ref={textAreaRef}
                            id="review-text"
                            value={reviewText}
                            onChange={e => handleReviewTextChange(e.target.value)}
                            className="flex-1 self-stretch justify-start text-[#393939] text-[13px] font-normal font-['Montserrat'] leading-none bg-transparent border-none outline-none focus:outline-none resize-none"
                            placeholder="Montre à tes amis ton cœur et ta bonne foi..."
                            rows={5}
                        />
                    </div>
                    <div className="self-stretch p-3 bg-[#efefef] border-t border-[#e4e4e4] inline-flex justify-between items-center relative overflow-visible">
                        <div className="justify-center">
                            <span className="text-[10px] font-bold font-['Montserrat'] leading-3 text-[#525254]">
                                {remainingChars}
                            </span>
                            <span className="text-[10px] font-normal font-['Montserrat'] leading-3 text-[#525254]">
                                {' caractères restants'}
                            </span>
                        </div>
                        <EmojiPickerInput
                            value={reviewText}
                            onChange={handleReviewTextChange}
                            inputRef={textAreaRef}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default TextEditor;
